import { render } from "./StudentRequirementsDataTable.vue?vue&type=template&id=573ea2ba&scoped=true"
import script from "./StudentRequirementsDataTable.vue?vue&type=script&lang=js"
export * from "./StudentRequirementsDataTable.vue?vue&type=script&lang=js"

import "./StudentRequirementsDataTable.vue?vue&type=style&index=0&id=573ea2ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573ea2ba"]])

export default __exports__